import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useStartSubscriptionView } from "@/hooks/useStartSubscriptionView";
import LoadingScreen from "@/components/shared/LoadingScreen";

/**
 * Deep-link target for `/subscription`.
 *
 * Triggers the subscription pane in the chat UI via useStartSubscriptionView(),
 * which clears the chatId from the URL and navigates to `/{activeNetworkId}`.
 * Primary caller: links rendered in oa-agent messages
 * (e.g. `[Manage your subscription](/subscription)`).
 */
export default function SubscriptionPage() {
  const { t } = useTranslation();
  const startSubscriptionView = useStartSubscriptionView();

  useEffect(() => {
    // `replace: true` so Back from /{networkId} doesn't bounce the user
    // back to /subscription (which would immediately redirect again).
    startSubscriptionView({ replace: true });
  }, [startSubscriptionView]);

  return <LoadingScreen title={t("loading")} />;
}
